import React, { Fragment, useState, forwardRef } from "react";
import { useHistory } from "react-router-dom";
import { Card } from "react-bootstrap";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import { Loader } from "@egovernments/digit-ui-react-components";
import { useTranslation } from "react-i18next";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { getOrderDocuments } from "../../../../../../utils";
import BPADocumentsPreview from "../../../../../../../../templates/ApplicationDetails/components/BPADocumentsPreview";
import { accordionSummaryStyles } from "../../../components/StyledComponent";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";

const EditSummaryFAR = ({ id, handleSubTabChange, handleTabChange }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [, applicationFlow] = useDepartmentSelector();
  const [, setIsPreviewLoading] = useState(false);
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("EMPLOYEE");
  const formType = "PURCHASABLE_FAR";
  const { data = {}, isLoading, refetch } = Digit.Hooks.obps.useBPADetailsPage(stateId, { isEmployee, formType }, { formType });
  const formData = data?.PurchasableFAR?.[0];
  const owners = formData?.landInfo?.owners;

  console.log(data, "fromSummary", formData);
  const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const nameOfDepartment = applicationFlow == "DA" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";
  const docs = formData?.documents || {};
  const approvedLayout = formData?.approvedLayout === "Yes";

  const normalizeDocuments = (docs) => {
    if (docs && typeof docs === "object" && !Array.isArray(docs)) {
      return Object.values(docs);
    }
    return docs;
  };

  const documents = normalizeDocuments(docs);

  let improvedDoc = [];

  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });

  const { data: pdfDetails, isLoading: docsLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: improvedDoc?.length > 0 ? true : false,
  });

  let applicationDocs = [];
  if (pdfDetails?.pdfFiles?.length > 0) {
    pdfDetails?.pdfFiles?.map((pdfAppDoc) => {
      if (pdfAppDoc?.module === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  const ownerInfo = formData?.landInfo?.owners?.[0];
  const descriptionOfLand = formData?.descriptionOfLand?.properties?.[0];
  console.log("description", descriptionOfLand);

  const checklist1 = formData?.checklist?.firstCheckList;
  const checklist2 = formData?.checklist?.secondCheckList;

  const step1Docs = applicationDocs.filter((doc) =>
    [
      "ownershipDoc",
      "sitePlan",
      "khataKhasraDocs",
      "allotmentLetter",
      "possessionLetter",
      "registry",
      "hpta",
      "paymentStatus",
      "mutationDocument",
    ].includes(doc.documentType)
  ); // removing photo and signature from documents
  const documentSection = applicationDocs.filter((doc) =>
    [
      "completeDrawingFile",
      "kmlFile",
      "sajraPlan",
      "landOwnershipDoc",
      "sitePlan",
      "khataKhasraDocs",
      "allotmentLetter",
      "possessionLetter",
      "registry",
      "hpta",
      "paymentStatus",
      "proposalDocument",
      "parkingProposalDoc",
      "drawingFile",
      "structuralCertificate",
      "fireDepartmentCertificate",
      "mutationDocument",
    ].includes(doc.documentType)
  );
  console.log("documentSectionSummary", documentSection);

  const personalDocs = applicationDocs.filter((doc) => ["signature", "applicantPhoto"].includes(doc.documentType)); // extracting photo and signature from documents
  console.log("personalDOcs", personalDocs);
  const proposalDocument = applicationDocs?.filter((doc) => ["proposalDocument"].includes(doc.documentType))?.[0]?.fileStoreId;
  const drawingFile = applicationDocs?.filter((doc) => ["drawingFile"].includes(doc.documentType))?.[0]?.fileStoreId;
  const structuralCertificate = applicationDocs?.filter((doc) => ["structuralCertificate"].includes(doc.documentType))?.[0]?.fileStoreId;
  const fireDepartmentCertificate = applicationDocs?.filter((doc) => ["fireDepartmentCertificate"].includes(doc.documentType))?.[0]?.fileStoreId;

  if (!formData && docsLoading) return <Loader />;
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
      }}
    >
      <div style={{ display: "flex", padding: "5px", background: "rgb(230, 239, 248)" }}>
        <div style={{ background: "white", borderRadius: "50%" }}>
          <img width="60" height="30" src={urlImg} alt="Uttar-Pradesh-Logo" />
        </div>
        <div style={{ color: "#1f4a7c" }}>
          <p style={{ marginLeft: "12px", fontSize: "1.25rem", fontWeight: "600", fontFamily: "Montserrat" }}>{nameOfDepartment}</p>
          <p style={{ marginLeft: "12px", fontFamily: "Montserrat", fontWeight: "500" }}>Government of Uttar Pradesh</p>
        </div>
      </div>

      <div className="container1" style={{ width: "100%", marginTop: "1rem" }}>
        {
          <Card className="formContainer">
            <Accordion expanded={true}>
              <AccordionSummary sx={accordionSummaryStyles}>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                  <div className="formHeaderContainer">
                    <h2 className="formHeading">{t("LABEL_APPLICANT_DETAILS")}</h2>
                  </div>

                  <span
                    style={{ display: "flex", color: "#1f4a7", alignItems: "center", cursor: "pointer" }}
                    onClick={() => {
                      handleTabChange(0);
                      handleSubTabChange(1);
                    }}
                  >
                    Edit
                    <EditNoteRoundedIcon />
                  </span>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                  <div style={{ flex: "1 1 calc(50% - 10px)", marginRight: "10px" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        {ownerInfo?.name && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_NAME")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.name}</td>
                          </tr>
                        )}
                        {ownerInfo?.fatherOrHusbandName && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_FATHER_NAME")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.fatherOrHusbandName}</td>
                          </tr>
                        )}
                        {ownerInfo?.gender && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_GENDER")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.gender}</td>
                          </tr>
                        )}
                        {ownerInfo?.mobileNumber && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_MOBILE_NUMBER")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.mobileNumber}</td>
                          </tr>
                        )}
                        {ownerInfo?.emailId && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_EMAIL_ID")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.emailId}</td>
                          </tr>
                        )}
                        {ownerInfo?.aadhaarNumber && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_AADHAR_CARD")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.aadhaarNumber}</td>
                          </tr>
                        )}
                        {descriptionOfLand?.propertyNo && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_PROPERTY_NO")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.propertyNo}</td>
                          </tr>
                        )}
                        {descriptionOfLand?.plotArea && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_PLOT_AREA")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.plotArea}</td>
                          </tr>
                        )}
                        {ownerInfo?.correspondenceAddress.town && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_CITY")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.correspondenceAddress.town}</td>
                          </tr>
                        )}
                        {ownerInfo?.correspondenceAddress.address && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_ADDRESS")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.correspondenceAddress.address}</td>
                          </tr>
                        )}
                        {descriptionOfLand?.schemeName && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Scheme")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.schemeName}</td>
                          </tr>
                        )}
                        {ownerInfo?.correspondenceAddress.state && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_STATE")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.correspondenceAddress.state}</td>
                          </tr>
                        )}
                        {ownerInfo?.correspondenceAddress.pinno && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_PIN_CODE")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.correspondenceAddress.pinno}</td>
                          </tr>
                        )}
                        {descriptionOfLand?.constructionType && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Construction Type")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.constructionType}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {owners?.map(
                    (item, index) =>
                      item?.photo && (
                        <div
                          key={index} // Added key for each item
                          style={{
                            flex: "1 1 calc(50% - 10px)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-around",
                            alignItems: "center",
                            padding: "24px",
                          }}
                        >
                          <div className="row" style={{ marginBottom: "10px" }}>
                            {item?.photo ? (
                              <img
                                style={{ width: "200px", height: "180px", objectFit: "cover" }}
                                src={item.photo}
                                alt="image"
                                className="img-thumbnail"
                              />
                            ) : (
                              <Avatar style={{ width: "200px", height: "80px" }}>{item?.photo}</Avatar>
                            )}
                          </div>
                          <div className="row" style={{ marginBottom: "10px", marginTop: "84px" }}>
                            {item?.signature ? (
                              <img style={{ width: "200px", height: "80px" }} src={item.signature} alt="signature" className="img-thumbnail" />
                            ) : (
                              <BorderColorIcon style={{ width: "70px", height: "25px" }}>{item?.signature}</BorderColorIcon>
                            )}
                          </div>
                        </div>
                      )
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        }

        {/* Applicant Information */}

        <Card className="formContainer">
          <Accordion expanded={true}>
            <AccordionSummary sx={accordionSummaryStyles}>
              <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">{t("Layout Details")}</h2>
                </div>
                <span
                  style={{ display: "flex", color: "#1f4a7", alignItems: "center", cursor: "pointer" }}
                  onClick={() => {
                    handleTabChange(0);
                    handleSubTabChange(2);
                  }}
                >
                  Edit
                  <EditNoteRoundedIcon />
                </span>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "100%" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      {formData?.approvedLayout && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_PLOT_PART_OF_APPROVED_LAYOUT")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.approvedLayout}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.schemeName && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Scheme Name")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.schemeName}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.plotNo && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Plot No.")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.plotNo}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.landUseAsPerLayout && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{formData?.approvedLayout == "No" ? t("Land Use as per Master Plan") : t("Land Use as per Approved Layout Plan")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landUseAsPerLayout}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.subLandUseAsPerLayout && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{formData?.approvedLayout == "No" ? t("Proposed Use as per Map") : t("Land Sub Use as per Layout")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.subLandUseAsPerLayout}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.landLength && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Plot Depth")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landLength}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.landArea && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Land Area (in Sq. M)")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landArea}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.roadWidth && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Existing Road Width")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.roadWidth}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.approachRoadWidth && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Approach Road Width (as per the actual plan)")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.approachRoadWidth}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.landMark && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Near by Landmark")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landMark}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.landAddress && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Land Address")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landAddress}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.constructionType && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Development Zone")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.constructionType}</td>
                        </tr>
                      )}

                      {!approvedLayout && (
                        <Fragment>
                          {descriptionOfLand?.khasraNo && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>{t("LABEL_KHASRA_NO")}</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.khasraNo}</td>
                            </tr>
                          )}
                          {descriptionOfLand?.khatauniNo && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>{t("LABEL_KHATAUNI_NO")}</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.khatauniNo}</td>
                            </tr>
                          )}
                          {descriptionOfLand?.khataNo && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>{t("LABEL_KHATA_NO")}</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.khataNo}</td>
                            </tr>
                          )}
                          {descriptionOfLand?.plotNo && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>{t("LABEL_PLOT_NO")}</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.plotNo}</td>
                            </tr>
                          )}
                          {descriptionOfLand?.landWidth && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>{t("LABEL_LAND_WIDTH")}</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landWidth}</td>
                            </tr>
                          )}
                        </Fragment>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </Card>
        <Card className="formContainer">
          <Accordion expanded={true}>
            <AccordionSummary sx={accordionSummaryStyles}>
              <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">{t("FAR Details")}</h2>
                </div>

                <span
                  style={{ display: "flex", color: "#1f4a7", alignItems: "center", cursor: "pointer" }}
                  onClick={() => {
                    handleTabChange(0);
                    handleSubTabChange(3);
                  }}
                >
                  Edit
                  <EditNoteRoundedIcon />
                </span>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "100%" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      {descriptionOfLand?.takenFAR && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_ALREADY_TAKEN_FAR")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.takenFAR}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.takenFAR == "Yes" && descriptionOfLand?.purchasableFAR && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_TAKEN_PURCHASABLE_FAR")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.purchasableFAR}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.percentRequiredFAR && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_REQUIRED_FAR_PERCENTAGE")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.percentRequiredFAR}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.requiredAreaFAR && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_REQUIRED_FAR_AREA")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.requiredAreaFAR}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </Card>
        {documentSection.length > 0 && (
          <Card className="formContainer">
            <Accordion expanded={true}>
              <AccordionSummary sx={accordionSummaryStyles}>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                  <div className="formHeaderContainer">
                    <h2 className="formHeading">{t("Documents Section")}</h2>
                  </div>

                  <span
                    style={{ display: "flex", color: "#1f4a7", alignItems: "center", cursor: "pointer" }}
                    onClick={() => {
                      handleTabChange(1);
                    }}
                  >
                    Edit
                    <EditNoteRoundedIcon />
                  </span>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer">
                  {
                    <BPADocumentsPreview
                      documents={getOrderDocuments(documentSection)}
                      svgStyles={{}}
                      isSendBackFlow={false}
                      isHrLine={true}
                      titleStyles={{ fontSize: "18px", lineHeight: "24px", fontWeight: 700, marginBottom: "10px" }}
                    />
                  }
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
        {checklist1?.setbackPosition?.front && (
          <Card className="formContainer">
            <Accordion expanded={true}>
              <AccordionSummary sx={accordionSummaryStyles}>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                  <div className="formHeaderContainer">
                    <h2 className="formHeading">{t("Checklist 1")}</h2>
                  </div>

                  <span
                    style={{ display: "flex", color: "#1f4a7", alignItems: "center", cursor: "pointer" }}
                    onClick={() => {
                      handleTabChange(2);
                    }}
                  >
                    Edit
                    <EditNoteRoundedIcon />
                  </span>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "100%" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_SETBACK_POSITION")}</b>
                          </td>
                        </tr>

                        {checklist1?.setbackPosition?.front && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Front")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.setbackPosition?.front}</td>
                          </tr>
                        )}
                        {checklist1?.setbackPosition?.rear && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Rear")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.setbackPosition?.rear}</td>
                          </tr>
                        )}
                        {checklist1?.setbackPosition?.left && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Left")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.setbackPosition?.left}</td>
                          </tr>
                        )}
                        {checklist1?.setbackPosition?.right && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Right")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.setbackPosition?.right}</td>
                          </tr>
                        )}
                        {checklist1?.buildingHeight && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Height of Proposed Building (m)")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.buildingHeight}</td>
                          </tr>
                        )}
                        {proposalDocument && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Proposal Document (PDF)")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>
                              {
                                <FaFilePdf
                                  color="#a10505"
                                  style={{ width: "20px", height: "30px" }}
                                  onClick={() => getDocumentByFileStoreId(proposalDocument, setIsPreviewLoading)}
                                />
                              }
                            </td>
                          </tr>
                        )}
                        {drawingFile && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Proposal Document (PDF)")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>
                              {
                                <FaFilePdf
                                  color="#a10505"
                                  style={{ width: "20px", height: "30px" }}
                                  onClick={() => getDocumentByFileStoreId(drawingFile, setIsPreviewLoading)}
                                />
                              }
                            </td>
                          </tr>
                        )}
                        {checklist1?.structuralSafety && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Structural Safety Certificate Applicable")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.structuralSafety}</td>
                          </tr>
                        )}
                        {structuralCertificate && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Structural Safety Certificate")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>
                              {
                                <FaFilePdf
                                  color="#a10505"
                                  style={{ width: "20px", height: "30px" }}
                                  onClick={() => getDocumentByFileStoreId(structuralCertificate, setIsPreviewLoading)}
                                />
                              }
                            </td>
                          </tr>
                        )}
                        {fireDepartmentCertificate && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Fire Department Certificate")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>
                              {
                                <FaFilePdf
                                  color="#a10505"
                                  style={{ width: "20px", height: "30px" }}
                                  onClick={() => getDocumentByFileStoreId(fireDepartmentCertificate, setIsPreviewLoading)}
                                />
                              }
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ width: "100%", textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_PARKING_ARRANGEMENT")}</b>
                          </td>
                        </tr>
                        {checklist1?.totalParkingRequired && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Total Parking Required")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.totalParkingRequired}</td>
                          </tr>
                        )}
                        {checklist1?.totalParkingProposed && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("No of Parking Proposed (As per Map)")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.totalParkingProposed}</td>
                          </tr>
                        )}

                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_PROVISION_PROPOSED_PLAN")}</b>
                          </td>
                        </tr>

                        <tr>
                          <td style={{ textAlign: "left", padding: "8px" }}>
                            <b>{t("In Basement")}</b>
                          </td>
                          {checklist1?.parkingProvision?.inBasement?.cars && (
                            <>
                              <td style={{ width: "50%", textAlign: "center", padding: "8px" }}>
                                <b>{t("No. of Cars")}:</b>
                                {checklist1?.parkingProvision?.inBasement?.cars}
                              </td>
                            </>
                          )}
                        </tr>

                        <tr>
                          <td style={{ textAlign: "left", padding: "8px" }}>
                            <b>{t("In Open Area")}</b>
                          </td>
                          {checklist1?.parkingProvision?.openArea?.cars && (
                            <>
                              <td style={{ width: "50%", textAlign: "center", padding: "8px" }}>
                                <b>{t("No. of Cars")}:</b>
                                {checklist1?.parkingProvision?.openArea?.cars}
                              </td>
                            </>
                          )}
                        </tr>

                        <tr>
                          <td style={{ textAlign: "left", padding: "8px" }}>
                            <b>{t("In Stilt Area")}</b>
                          </td>
                          {checklist1?.parkingProvision?.inStiltArea?.cars && (
                            <>
                              <td style={{ width: "50%", textAlign: "center", padding: "8px" }}>
                                <b>{t("No. of Cars")}:</b>
                                {checklist1?.parkingProvision?.inStiltArea?.cars}
                              </td>
                            </>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
        {checklist2?.publicSewerageOrSepticTank && (
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary sx={accordionSummaryStyles}>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                  <div className="formHeaderContainer">
                    <h2 className="formHeading">{t("Checklist 2")}</h2>
                  </div>

                  <span
                    style={{ display: "flex", color: "#1f4a7", alignItems: "center", cursor: "pointer" }}
                    onClick={() => {
                      handleTabChange(2);
                    }}
                  >
                    Edit
                    <EditNoteRoundedIcon />
                  </span>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "100%" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Existing road width in meters")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.existingRoadWidth || ""}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Provision of Sewerage & Drainage")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.publicSewerageOrSepticTank || ""}</td>
                        </tr>

                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Provision of Water Supply")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.waterSupplyArrangement || ""}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Mode of Solid waste disposal")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.solidWasteDisposal || ""}</td>
                        </tr>

                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Mode of Garbage collection")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.garbageCollection || ""}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Provision of Power supply")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.powerSupply}</td>
                        </tr>

                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Provision of Rain Water Harvesting")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.rainWaterHarvesting}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Provision of Solar Water Heating system")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.solarWaterHeating}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
        {(formData?.descriptionOfLand?.googleMapCoordinates || formData?.descriptionOfLand?.googleMapLocation) && (
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary sx={accordionSummaryStyles}>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                  <div className="formHeaderContainer">
                    <h2 className="formHeading">Location Information</h2>
                  </div>

                  <span
                    style={{ display: "flex", color: "#1f4a7", alignItems: "center", cursor: "pointer" }}
                    onClick={() => {
                      handleTabChange(3);
                    }}
                  >
                    Edit
                    <EditNoteRoundedIcon />
                  </span>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "100%" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        {formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.latitude && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Map Cordinates:</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>
                              Latitude: {formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.latitude}, Longitude:{" "}
                              {formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.longitude}
                            </td>
                          </tr>
                        )}
                        {formData?.descriptionOfLand?.googleMapLocation && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Map Location:</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.googleMapLocation}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
        {formData?.assignLTP === "Yes" && (
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={
                  <span style={{ display: "flex", color: "#1f4a7" }}>
                    Edit
                    <EditNoteRoundedIcon />
                  </span>
                }
                sx={accordionSummaryStyles}
              >
                <div className="formHeaderContainer">
                  <h2 className="formHeading">Assign file to License Technical Person(LTP)</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "100%" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        {formData?.professionalInformation?.ltpName && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{`${t("Selected LTP")} :`}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData?.professionalInformation?.ltpName}</td>
                          </tr>
                        )}
                        {formData?.professionalInformation?.ltpRegistrationNumber && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{`${t("Registration No.")} :`}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData?.professionalInformation?.ltpRegistrationNumber}</td>
                          </tr>
                        )}
                        {formData?.professionalInformation?.ltpCity && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{`${t("City Name")} :`}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData?.professionalInformation?.ltpCity}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
        {Boolean(formData?.taxHeadEstimates?.[0]?.estimateAmount) && (
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={
                  <span style={{ display: "flex", color: "#1f4a7" }}>
                    Edit
                    <EditNoteRoundedIcon />
                  </span>
                }
                sx={accordionSummaryStyles}
              >
                <div className="formHeaderContainer">
                  <h2 className="formHeading">Processing Fee for Purchasable FAR</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer">
                  <div style={{ display: "flex" }}>
                    <b>Total Amount</b>
                    <p style={{ marginLeft: "1rem" }}>
                      <span>₹ {formData?.taxHeadEstimates?.[0]?.estimateAmount}</span>
                    </p>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
      </div>
    </div>
  );
};

export default EditSummaryFAR;
